<div class="cpcontent">
  <!-- Header Data ---------------------------------------------------------------------->
  <h2 *ngIf="scenario.id == 0" title="id: {{scenario.id}}" style="display:inline-block" title="Id: {{scenarioId}}">Add Scenario (Id:{{scenarioId}})</h2>
  <h2 *ngIf="scenario.id > 0" title="id: {{scenario.id}}" style="display:inline-block;margin-right:50px" title="Id: {{scenarioId}}">Edit Scenario (Id:{{scenarioId}})</h2>

  <sa-input-text class="inlineform" [(text)]="scenario.name" [title]="'Name'" [required]="'none'"></sa-input-text>
  <sa-select *ngIf="hasRole('Administrator')" class="inlineform"  [(Id)]="scenario.organizationId" [title]="'Organization'" [options]="organizations"></sa-select>
  <sa-label *ngIf="! hasRole('Administrator')" class="inlineform" [text]="scenario.organizationName" [title]="'Organization'"></sa-label>
  <sa-label class="inlineform" [text]="scenario.versionId" [title]="'Scenario Version'"></sa-label>

  <div style="display:inline-block">
    <sa-input-radio [selectedType]="scenario.selectedType" [title]="''" [types]="['GPS','Beacon']" (selectedTypeChange)="selectedTypeChange($event)"></sa-input-radio>
  </div>
  <button class="inlineform" class="btn btn-primary" style="margin-left:10px" (click)="save()">Save</button>

  <button class="inlineform" class="btn btn-info btn-sm" style="margin-left:10px;float:right;margin-top:50px;" (click)="showInstructions = !showInstructions">Scenario Edit Help</button>
  <!--- INfo ---------------------------------------------------------------------------------------->
  <div *ngIf="showInstructions" style="border:solid 1px rgb(0, 0, 0);border-radius:5px;margin:10px;padding:10px;background-color: rgb(242, 242, 242);">
    <h5>Instructions</h5>
    Here is where a teacher can create or change a scenario.<br>
    General information about the application can be found on the home page.<br>
    <b>The main decision is to use a GPS based simulator or a BlueTooth based simulator. Click the radio buttons to make this decision.</b>
    <br>
    Each tab has an instruction button explaining more about the individual tab.
  </div>

  <!-- tab definitions  ------------------------------------------------------------------------------>
  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#description" type="button" role="tab" aria-controls="description" aria-selected="true" aria-expanded="true">
        Description</button>
    </li>
    <li *ngIf="scenario.hasGPS" class="nav-item" role="presentation">
      <button class="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#hazardgeometry" type="button" role="tab" aria-controls="home2" aria-selected="false">
        Hazard Geometry</button>
    </li>
    <li *ngIf="scenario.hasGPS" class="nav-item" role="presentation">
      <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#gpssensors" type="button" role="tab" aria-controls="profile3" aria-selected="false">
        Sensors</button>
    </li>
    <li *ngIf="scenario.hasGPS" class="nav-item" role="presentation">
      <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#qrcode" type="button" role="tab" aria-controls="profile4" aria-selected="false">
        QR Code</button>
    </li>
    <li *ngIf="!scenario.hasGPS" class="nav-item" role="presentation">
      <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#beacon" type="button" role="tab" aria-controls="profile5" aria-selected="false">
        Sensors</button>
    </li>
    <li *ngIf="scenario.hasGPS" class="nav-item" role="presentation">
      <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#gpslog" type="button" role="tab" aria-controls="profile5" aria-selected="false">
        Exercise Log</button>
    </li>
    <li *ngIf="!scenario.hasGPS" class="nav-item" role="presentation">
      <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#beaconlog" type="button" role="tab" aria-controls="profile5" aria-selected="false">
        Exercise Log</button>
    </li>

  </ul>

  <!-- tabs start here ------------------------------------------------------------------------------>
  <div class="tab-content" id="myTabContent">

    <!--- Tab Description --------------------------------------------------------->
    <div class="tab-pane fade show active" id="description" role="tabpanel" aria-labelledby="home-tab">

      Enter a description of the field exercise, including the sensors involved and expected responses of students.
      Check other scenarios for examples.
      <br><br>
      <button *ngIf="showEditor == false" class="btn btn-primary btn-sm" (click)="showEditor = true">Edit Text</button><br>
      <div style="max-width:1200px" *ngIf="showEditor">
        <app-richtext [content]="scenario.description" (contentChange)="descriptionChanged($event)"></app-richtext>
      </div>
      <div *ngIf="showEditor == false" style="max-width:1000px;margin-left:50px">
        <span [innerHTML]="scenario.description"></span>
      </div>

    </div>

    <!--- Tab hazardgeometry--------------------------------------------------------->
    <div [hidden]="!hasGPS" class="tab-pane fade" id="hazardgeometry" role="tabpanel" aria-labelledby="home2-tab">
      <app-scenariolayout #scenlay (saveScenario)="saveScenario($event)"></app-scenariolayout>
    </div>

    <!--- Tab GPS Sensor --------------------------------------------------------->
    <div *ngIf="scenario.hasGPS" class="tab-pane fade" id="gpssensors" role="tabpanel" aria-labelledby="profile3-tab">
      <h4 style="display:inline-block">Sensor Settings</h4>
      <button class="btn btn-info btn-sm" style="float:right;margin-top:5px" (click)="showTabGPSSensor = !showTabGPSSensor">Instructions</button>
      <div *ngIf="showTabGPSSensor" style="border:solid 1px rgb(0, 0, 0);border-radius:5px;margin:10px;padding:10px;background-color: rgb(242, 242, 242);">
        <h5>Instructions</h5>
        In this tab you can associate the contours in tab "GPS" with sensor to be displayed on the mobile phone.
        You select from a list of available sensors from the right side.
        For each selected sensor (left side) you specify the following values:
        <ul>
          <li>Seq No: determines in which sequence the sensors are displayed</li>
          <li>Max Value: determines the sensor value at the innermost circle or contour</li>
          <li>Threshold: determines at what exposure reading an alarm will sound</li>
        </ul>
      </div>


      Convert height in scenarion to sensor readings.<br>
      Pick any sens and then specify its maximum reading at the center of the scenario
      <div class="row">
        <div class="col-md-8">
          <table class="table table-bordered" style="width:100%">
            <thead>
              <tr>
                <th>Sensor</th>
                <th>Seq No</th>
                <th>Max</th>
                <th>Threshold</th>
                <!-- <th></th> -->
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let ss of scenariosensors">
                <td>{{lookup(ss.sensorId,sensors)}}</td>
                <td title="Id: {{ss.id}}"><input style="max-width:100px" type="number" [(ngModel)]="ss.seqNo" /></td>
                <td>
                  <div><input style="max-width:100px" type="number" [(ngModel)]="ss.gpsMaxReading" /></div>
                </td>
                <td><input style="max-width:100px" type="number" [(ngModel)]="ss.threshold" /></td>
                <!-- <td><button class="btn btn-primary btn-sm" (click)="saveScenarioSensor(ss)">Save</button></td> -->
                <td>
                  <i class="bi bi-trash"  style="font-size: 1.5em;color:orange" (click)="deleteScenarioSensor(ss)"></i>
                  <!-- <button class="btn btn-warning btn-sm" (click)="deleteScenarioSensor(ss)">Remove</button> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-4">
          Pick any sensor from the list to include in the scenario
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Sensor</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let s of sensors">
                <td title="Id: {{s.id}}" class="link" (click)="addSensorToScenarioSensors(s)">{{s.name}}</td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>

    <!--- Tab QR-Code --------------------------------------------------------->
    <div *ngIf="scenario.hasGPS" class="tab-pane fade" id="qrcode" role="tabpanel" aria-labelledby="profile4-tab">
      Students can use the following QR Code for this scenario<br>

      <qrcode [qrdata]="qrdata" [width]="400" [errorCorrectionLevel]="'M'"></qrcode>
      {{qrdata}}
    </div>

    <!--- Tab GPS Log --------------------------------------------------------->
    <div *ngIf="scenario.hasGPS" class="tab-pane fade" id="gpslog" role="tabpanel" aria-labelledby="profile5-tab">
      <app-logscengps [scenarioId]="scenarioId"></app-logscengps>
    </div>

    <!--- Tab Beacon --------------------------------------------------------->
    <div [hidden]="hasGPS" class="tab-pane fade" id="beacon" role="tabpanel" aria-labelledby="profile5-tab">
      <app-beaconscenario #beaconscenid [scenarioId]="scenarioId"></app-beaconscenario>
    </div>

    <!--- Tab Beacon Log --------------------------------------------------------->
    <div *ngIf="!scenario.hasGPS" class="tab-pane fade" id="beaconlog" role="tabpanel" aria-labelledby="profile5-tab">
      <app-logscenbeacon [scenarioId]="scenarioId"></app-logscenbeacon>
    </div>
  </div>
</div>

<br>
<!-- Scenario table properties ------------------------------------------------------------------->
<button class="btn btn-info btn-sm" (click)="viewObjects = !viewObjects">View JSON Obects</button>
<div *ngIf="viewObjects" class="row" style="margin-left:20px">
  KML: {{scenario.kmlstring | limitTo: 20}}<br>
  Geometry: {{scenario.geometryJson | limitTo: 20}}<br>
  <div class="row">
    <div class="col-md-6">
      <div>Scenario</div>
      <pre id="json">{{scenario | json}}</pre>
    </div>
    <div class="col-md-6">
      <div>Scenariolayout</div>
      <pre id="json">{{scenariolayout | json}}</pre>
    </div>
  </div>
</div>